import { Component } from "react";
import { graphql } from "gatsby";
import styles from "./ride-block.module.less";
import borderPatterns from "styles/theming/border-patterns.module.less";
import { extract } from "@parksandresorts/core";

export default class RideBlock extends Component {
  constructor(props) {
    super(props);
    this.title = extract(props, "title");
    this.preamble = extract(props, "preamble.preamble");
    this.description = extract(props, "description.childMarkdownRemark.html");
    this.backgroundMode = extract(props, "backgroundMode");
    this.id = extract(props, "id");
    this.mapLinkInternal = extract(props, "mapLink.internalLink.slug");
    this.mapLink = this.mapLinkInternal ? this.mapLinkInternal : extract(props, "mapLink.externalUrl");
    this.mapLinkInNewTab = extract(props, "mapLink.openInNewTab");
    this.borderPattern = extract(props, "borderPattern");
    this.componentTheme = extract(props, "componentTheme");
  }

  render() {
    return (
      <section
        className={[
          `block block--with-utility`,
          this.componentTheme ? `component-theme-${this.componentTheme}` : "",
          styles.rideBlock,
          borderPatterns[this.borderPattern + "_top"],
        ].join(" ")}
        data-contentful-id={this.props.contentful_id}
      >
        <div className={["block--max-width block--floating", styles.outerWrapper].join(" ")}>
          <div className={["block--padded", styles.contentWrapper].join(" ")}>
            {this.title && <h1 className={[styles.title, "hero-heading text--with-shadow"].join(" ")}>{this.title}</h1>}
            {this.preamble && (
              <div className={[styles.preamble, "preamble text--with-shadow"].join(" ")}>{this.preamble}</div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export const fragmentRideBlock = graphql`
  fragment RideBlock on ContentfulRideBlock {
    __typename
    contentful_id
    id
    sortIndex
    rideId
    title
    borderPattern
    componentTheme
    couponCount
    minimumHeight
    minimumHeightInteger
    noHeightRequirement
    ageRequirement
    separateTickets
    rideDifficultyLevel
    preamble {
      preamble
    }
    description {
      childMarkdownRemark {
        html
      }
    }
    shortDescriptionInList
    imageInList {
      ...Asset
    }
    label
    pageLink {
      slug
    }
    # We create an alias here because of inconsistent naming between Contentful environments. Core expects ridePageLink.
    ridePageLink: pageLink {
      slug
    }
    tags {
      title
    }
    mapLink {
      ...Link
    }
    queueDisplayCategory {
      ...Tag
    }
  }
`;

export const fragmentRideBlockStore = graphql`
  fragment RideBlockStore on ContentfulRideBlock {
    id
    contentful_id
    node_locale
    sortIndex
    rideId
    title
    preamble {
      preamble
    }
    description {
      childMarkdownRemark {
        html
      }
    }
    shortDescriptionInList
    imageInList {
      file {
        url
      }
    }
    label
    tags {
      title
    }
    pageLink {
      slug
    }
    # We create an alias here because of inconsistent naming between Contentful environments. Core expects ridePageLink.
    ridePageLink: pageLink {
      slug
    }
    jetpassSelectSlotText
    mapLink {
      ...Link
    }
  }
`;
